// @tennis-matches/services/trainerstunden/billing-statement-overdue

import { resolveBillingStatementDueDateIso } from "./trainer-payment-due-days.js";

function nz(v) {
  return String(v ?? "").trim();
}

function resolveOpenEur(st, opts = {}) {
  const fromOpts = Number(opts.openEur);
  if (Number.isFinite(fromOpts)) return fromOpts;
  return Number(st?.open_eur) || 0;
}

/**
 * @param {object | null | undefined} st
 * @param {Date} [now]
 * @param {{ openEur?: number, issuerTrainer?: object | null }} [opts]
 */
export function isBillingStatementOverdue(st, now = new Date(), opts = {}) {
  const status = nz(st?.status);
  if (status !== "sent" && status !== "partially_paid") return false;
  const open = resolveOpenEur(st, opts);
  if (open <= 0.004) return false;
  const dueRaw = resolveBillingStatementDueDateIso(st, opts).slice(0, 10);
  if (!dueRaw) return false;
  const due = new Date(`${dueRaw}T12:00:00`);
  if (Number.isNaN(due.getTime())) return false;
  const today = new Date(now);
  today.setHours(0, 0, 0, 0);
  return due < today;
}

/**
 * @param {object | null | undefined} st
 */
export function isBillingStatementAwaitingPayment(st) {
  const status = nz(st?.status);
  if (status !== "sent" && status !== "partially_paid") return false;
  return (Number(st?.open_eur) || 0) > 0.004;
}

/**
 * @param {unknown[]} statements
 * @param {Date} [now]
 */
export function collectOverdueBillingStatements(statements, now = new Date()) {
  return (Array.isArray(statements) ? statements : []).filter((st) =>
    isBillingStatementOverdue(st, now),
  );
}

/**
 * @param {unknown[]} statements
 * @param {Date} [now]
 */
export function summarizeOverdueBillingStatements(
  statements,
  now = new Date(),
) {
  const rows = collectOverdueBillingStatements(statements, now);
  const count = rows.length;
  const totalEur =
    Math.round(
      rows.reduce((sum, r) => sum + (Number(r?.open_eur) || 0), 0) * 100,
    ) / 100;
  return { count, totalEur, rows };
}

/**
 * Kalendertage seit Fälligkeit (mindestens 1), 0 wenn nicht überfällig.
 * @param {object | null | undefined} st
 * @param {Date} [now]
 * @param {{ openEur?: number, issuerTrainer?: object | null }} [opts]
 */
export function computeBillingStatementOverdueDays(
  st,
  now = new Date(),
  opts = {},
) {
  if (!isBillingStatementOverdue(st, now, opts)) return 0;
  const dueRaw = resolveBillingStatementDueDateIso(st, opts).slice(0, 10);
  const due = new Date(`${dueRaw}T12:00:00`);
  if (Number.isNaN(due.getTime())) return 0;
  const today = new Date(now);
  today.setHours(0, 0, 0, 0);
  const diffMs = today.getTime() - due.getTime();
  return Math.max(1, Math.floor(diffMs / (24 * 60 * 60 * 1000)));
}
